import { Row, Col } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { StyledTableLabel } from '../../../../layout/newGlobalFonts';
import { ColorScheme } from '../../../../layout/colorScheme';
import ContentStore from '../../../../stores/ContentStore';

const TableTitleRow = styled(Row)`
  padding: 16px 8px 16px 30px;
  margin-inline: 0;
  min-height: 70px;
  align-items: center;
`;

const FlexEndColumn = styled(Col)`
  display: flex;
  justify-content: flex-end;
  padding-right: 18px !important;
`;

const StyledCol = styled(Col)`
  padding-left: 0px !important;
`;

interface TransactionsAndUsageTableMobileColumnTitleRowProps {
  contentStore: ContentStore;
}

const TransactionsAndUsageTableMobileColumnTitleRow: FC<
  TransactionsAndUsageTableMobileColumnTitleRowProps
> = (props) => {
  const { contentStore } = props;
  const { transactionsStore } = contentStore.rootStore;
  return (
    <TableTitleRow gutter={12}>
      <StyledCol span={5}>
        <StyledTableLabel $color={ColorScheme.Grey6}>
          {
            contentStore.cmsStore.getContent(
              transactionsStore.activeTab === 1 ? 'Date' : 'TransactionsAndUsageTableDueDate'
            )?.content
          }
        </StyledTableLabel>
      </StyledCol>
      <StyledCol span={10}>
        <StyledTableLabel $color={ColorScheme.Grey6}>
          {contentStore.cmsStore.getContent('ProductOrReference')?.content}
        </StyledTableLabel>
      </StyledCol>
      <FlexEndColumn span={9}>
        <StyledTableLabel $color={ColorScheme.Grey6}>
          {contentStore.cmsStore.getContent('AmountAndStatus')?.content}
        </StyledTableLabel>
      </FlexEndColumn>
    </TableTitleRow>
  );
};

export default TransactionsAndUsageTableMobileColumnTitleRow;
